import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/encryption.service';

@Component({
  selector: 'app-visitor-details',
  templateUrl: './visitor-details.component.html',
  styleUrls: ['./visitor-details.component.scss']
})
export class VisitorDetailsComponent implements OnInit {

  statusEnum = {
    WAITING: 'Pending',
    APPROVED: 'Approved',
    CANCELLED: 'Reject'
  };

  public add: any = {};
  public Visit_ID="";
  constructor(public appservice:AppService,private activeRoute: ActivatedRoute,private encryptionService: EncryptionService,
    private toastr: ToastrService, public router: Router, private http: HttpClient) {
      const encryptedNumber = this.activeRoute.snapshot.queryParamMap.get('url');
      if (encryptedNumber) {
        const decryptedNumber = this.encryptionService.decryptFromNumber(encryptedNumber);
        console.log(decryptedNumber); 
        const [encryptedCompany, encryptedVisitId] = decryptedNumber.split('-');
         this.appservice.Company = "_"+encryptedCompany;
         this.appservice.setItem("Company",encryptedCompany);
         this.Visit_ID = encryptedVisitId;
  
      }
      // this.Visit_ID = this.activeRoute.snapshot.queryParamMap.get('Visit_ID');
      // this.appservice.Company = "_"+this.activeRoute.snapshot.queryParamMap.get('Company');
      this.get_Visiting_Details();


  }

  get_Visiting_Details() {
    this.appservice.get("Api/Visitor/get_Visiting_Details?Visitor_ID="+this.Visit_ID).subscribe((res: any) => {
      this.add = JSON.parse(res).record[0];
      this.get_Area_Details(this.add.V_Branch||1)
    });
  }

// Welcome_Message: string = "";
//   public Area_Details_Rows: any[] = [];
//   get_Area_Details(ID: any) {
//     this.Area_Details_Rows = [];
//     this.appservice.get("Api/visitor/get_Area_Details?ID="+ID).subscribe((res: any) => {
//       this.Area_Details_Rows = JSON.parse(res).record;

//       this.appservice.Company_Name=this.Area_Details_Rows[0].Araa;
//          this.Welcome_Message = this.Area_Details_Rows[0].Welcome_Message;

//          console.log(this.Area_Details_Rows);
//     });

//   }

Welcome_Message: string = "";
public Area_Details_Rows: any[] = [];
get_Area_Details(ID: any) {
  this.Area_Details_Rows = [];

  this.appservice.get("Api/visitor/get_Area_Details?ID=" + ID)
    .subscribe((res: any) => {

      const data = JSON.parse(res).record;

      console.log("AREA DATA:", data); 

      this.Area_Details_Rows = data;

      if (data && data.length > 0) {

        this.appservice.Company_Name = data[0].Araa;

        
        this.Welcome_Message = data[0].Welcome_Message || "Welcome!";
      }
      else {
        this.Welcome_Message = "Welcome!";
      }

    });
}





  ngOnInit(): void {
  }

}
